<!--

	Creates a popup that contains the info from the scope and sequence control.

-->

<template>
	<modal :cross="cross">
		<template #title>
			<h3 v-tr="'scopeandsequence_modal_heading'" class="modal-title" />
		</template>
		<template #body>
			<scope-and-sequence-control :show-title="false" :show-description="true" :scope-and-sequence-links="scopeAndSequenceLinks" />
		</template>
	</modal>
</template>
<script lang="ts">
import { Component, Prop, toNative, Vue } from "vue-facing-decorator";
import ScopeAndSequenceControl from "./ScopeAndSequenceControl.vue";
import Cross from "@theme/cross.svg";
import { MiaPlaza } from "@/Reinforced.Typings";
import Modal from "@/Control/Vue/Notifications/Modal.vue";

@Component({
	components: {
		ScopeAndSequenceControl,
		Modal
	}
})
export class ScopeAndSequenceModal extends Vue {
	@Prop({ type: Object, required: true }) scopeAndSequenceLinks!: Record<MiaPlaza.Model.Subject, string>;

	readonly cross = Cross;
}

export default toNative(ScopeAndSequenceModal);
</script>
